EmptyStringDescriptionStore